import { IconPack } from 'runtime/registry/icons/types';
import { Options } from 'highcharts';
import { MenuItem } from 'constants/menuConfiguration';
import { IFormDescriptorItem } from 'types/Analytics';
import { FilterListItem, QuickFilterConfig } from 'types/QuickFilters';
import { configWl58, configWl19 } from '.';

export type FilterOverride = {
  hidden?: boolean;
  patch?: Partial<QuickFilterConfig>;
  list?: {
    add?: FilterListItem[];
    remove?: string[];
  };
  add?: QuickFilterConfig;
};

export type QuickFiltersOverride = Record<
  string,
  Record<string, FilterOverride>
>;

export type ResponsiveLayout<T> = {
  desktop?: T;
  mobile?: T;
};

export type LayoutValue<T> =
  | T
  | {
    desktop?: T;
    mobile?: T;
  };

export interface RuntimeComponentConfig {
  component?:
  | React.ComponentType<object>
  | React.LazyExoticComponent<React.ComponentType<any>>;

  props?: Record<string, any>;

  layout?: LayoutValue<Record<string, string[]>>;
}

export type ProfileFieldsOverride = Record<string, boolean>;

export interface WlConfig {
  version: string;
  iconLibrary: IconPack;
  components: Record<string, RuntimeComponentConfig>;
  isInternalSignup?: boolean;
  name: string;
  isNewDesignEnabled?: boolean;
  isNewComponentsEnabled?: boolean;
  componentsVersion?: string;
  menuConfiguration?: MenuItem[];
  quickFiltersOverride?: QuickFiltersOverride;
  profileFieldsOverride?: Record<string, ProfileFieldsOverride>;
  tableConfig?: {
    payments;
    invoices;
    teamUsers;
    teamActivities;
    projectCallbacks;
    reports;
    balanceRealTime;
  };
  chartStyleTransformer?: Options | null;
  chartOptionsTransformer?: (
    options: Highcharts.Options,
    chartType?: string
  ) => Highcharts.Options;
  chartSettingsFormConfig?: {
    [key: string]: IFormDescriptorItem[];
  };
  isHideLinksOnPage?: boolean;
  isHideSocialLinks?: boolean;
  isHideBalanceFilters?: boolean;
}

export const wlConfig: Record<number, WlConfig> = {
  58: configWl58,
  19: configWl19
};

export function getWlConfig(wlId: number): WlConfig | null {
  return wlConfig[wlId] ?? null;
}
